<template>
    <div class="sidebar" id="citiesId" @click.stop>
        <div class="logo">
            <a href="/"><img src="/img/logo.png"></a>
        </div>
        <div class="navage-sidebar">
            <ul>
                <li class=""><a href="/claim-listing" class="claim-listing">Claim Listing</a></li>
                <li class=""><a href="/submit-store">Add Store</a></li>
                <li class=""><a href="/map" class="claim-listing">Map</a></li>
                <li class=""><a href="/blog" class="claim-listing">Blog</a></li>
                <li><a href="/contact">Contact Us</a></li>
            </ul>
        </div>
        <div class="scroll-area">
            <div class="cities" id="nonitembased">
                <div class="contains">
                    <div class="input-field ">
                        <input type="text" v-model="query" v-on:keyup="autoComplete" name="search-city-input" class="form-control">
                        <label for="search-city-input" class="col-md-4 control-label">Search for your city</label>
                    </div>
                    <div class="panel-footer" v-if="results.length">
                        <div class="collection">
                            <a class="collection-item" v-for="result in results" :href="'/'+string_to_slug(result.country)+'/'+string_to_slug(result.region)+'/'+string_to_slug(result.city)">{{ result.city }}, {{ result.region }}, {{ result.country }}</a>
                        </div>
                    </div>
                    <div id="popular-cities">
                        <h3 class="center-align">Popular Cities</h3>
                        <ul class="slidee">
                            <li v-for="(country, index) in popular"><div class="country-link"><span class="country"><span class="country-flag"><img :src="'/img/flags/'+string_to_slug(index)+'.png'"></span> <span class="">{{ index }}</span></span>
                                <ul class="active-country">
                                    <li v-for="(city, index) in country"><div class="city-link"><a :href="'/'+city.country_slug+'/'+city.region_slug+'/'+city.city_slug"><span class="city">{{ index }}</span><span class="count">{{ city.counts }}</span></a></div></li>
                                </ul>
                            </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return {
                query: '',
                results: {},
                cities: {},
                popular: []
            }
        },
        created: function () {
            axios.get('/cities.json').then(response => {
                this.cities = response.data;
            });
            axios.get('/popular_cities.json').then(response => {
                this.popular = response.data;
        });
        },
        methods: {
            autoComplete(){
                if(this.query.length > 3){
                    this.results = [];
                    for(var i = 0; i < this.cities.length; i++) {
                        if (this.cities[i].city_slug.indexOf(this.string_to_slug(this.query)) > -1) {
                            this.results.push(this.cities[i]);
                        }
                    }
                }
            },

            string_to_slug(str) {
                str = str.replace(/^\s+|\s+$/g, ''); // trim
                str = str.toLowerCase();

                // remove accents, swap ñ for n, etc
                var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
                var to   = "aaaaeeeeiiiioooouuuunc------";
                for (var i=0, l=from.length ; i<l ; i++) {
                    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
                }

                str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
                    .replace(/\s+/g, '-') // collapse whitespace and replace by -
                    .replace(/-+/g, '-'); // collapse dashes

                return str;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/CitySearch.vue